<template>
  <v-card class="pa-4" flat>
    <v-card-title class="d-flex align-center justify-space-between mb-4">
      <span class="text-h5">مدیریت توکن‌ها</span>
      <v-btn
        @click="openAddPopup"
        class="rounded-lg btn-get-code"
      >
        افزودن توکن جدید
        <v-icon left>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>

    <v-progress-linear v-show="loading" class="mb-2" indeterminate />

    <!-- جدول لیست توکن‌ها -->
    <vue-table
      :data="tokensData"
      :headers="headers"
      :loading.sync="loading"
      @change="onPagination"
    >
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" md="2">
            <v-select
              v-model="props.length"
              :items="perPage"
              class="rounded-lg"
              dense
              hide-details
              label="تعداد در هر صفحه"
              outlined
              @change="onPagination"
            />
          </v-col>
          <v-col cols="12" md="3" class="pa-2" >
                        <v-select
                        v-model="props.route" 
                        :items="routes"
                        item-text="name"
                        item-value="id"
                        label="نوع"
                        outlined
                        dense
                        closable
                    @change="onPagination"

                        
                        >
            <template v-slot:selection="{ item }">
                <v-avatar size="24" class="ml-2" v-if="getRouteImage(item.name)">
                <img :src="getRouteImage(item.name)" :alt="item.name" />
                </v-avatar>
                {{ item.name }}
            </template>
            
            <template v-slot:item="{ item }">
                <v-avatar size="24" class="ml-2" v-if="getRouteImage(item.name)">
                <img :src="getRouteImage(item.name)" :alt="item.name" :sizes="20" />
                </v-avatar>
                {{ item.name }}
            </template>
            </v-select>
          </v-col>
        <v-col cols="12" md="3" class="pa-2" >
            <v-select
              v-model="props.status"
              :items="[{name:'همه',id:null},{name:'فعال',id:true},{name:'غیرفعال', id:false}]"
              item-text="name"
              item-value="id"
              label="وضعیت"
              outlined
              dense
            @change="onPagination"

            ></v-select>
          </v-col>
          <v-col class="pa-2" cols="12" md="3">
            <v-text-field
              v-model="props.search"
              append-icon="mdi-magnify"
              class="rounded-lg"
              clearable
              dense
              label="جستجو"
              outlined
              @click:append="applySearch"
              @keyup.enter="applySearch"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:index="{ item }">
        {{ item.index + 1 + (tokensData.current_page - 1) * tokensData.per_page }}
      </template>

      <template v-slot:token="{ item }">        
        <span class="text-truncate" style="max-width: 150px; display: inline-block;" :title="item.token">
          {{ item.token || "--" }}
        </span>

        <v-tooltip bottom content-class="rounded-lg">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    class="ma-1"
                    color="primary"
                    @click="copyToClipboard(item.token)"
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                    <span class="mr-1"></span>
                  </v-btn>
                </template>
                <span>کپی  توکن</span>

              </v-tooltip>

      </template>
      
      <template v-slot:enable="{ item }">
        <v-chip :color="item.enable ? 'success' : 'error'" small dark>
          {{ item.enable ? 'فعال' : 'غیرفعال' }}
        </v-chip>
      </template>
            <template v-slot:api_route_id="{ item }">
                            
        <v-chip :color="item.route?.type==='chat' ? '#C8F0AC' : item.route?.type==='image' ?'#F0D6AC':'#F0ACAC'" small>
            <v-avatar size="18" class="ml-2" v-if="getRouteImage(item.route.name)">
                <img :src="getRouteImage(item.route.name)" :alt="item.route.name" :sizes="20" />
                </v-avatar>
          {{ item.route.name}}

        </v-chip>
      </template>


      <template v-slot:action="{ item }">
        <manage-button :data="item" :meta="metaButtons" />
      </template>
    </vue-table>

    <!-- پاپ‌آپ افزودن/ویرایش -->
    <custom-popup
      v-model="showPopup"
      :cons="{ title: isEditing ? 'ویرایش توکن' : 'افزودن توکن جدید' }"
      max-width="600"
      @confirm="saveToken"
      @cancel="showPopup = false"
    >
      <v-form ref="form" v-model="valid" lazy-validation class="pa-4">
        <v-row>
          <v-col cols="12">
                        <v-select
                        v-model="formData.api_route_id" 
                        :items="routes"
                        item-text="name"
                        item-value="id"
                        label="نوع"
                        outlined
                        dense
                        required
                        :rules="[v => !!v || 'انتخاب نوع الزامی است']"
                        >
            <template v-slot:selection="{ item }">
                <v-avatar size="24" class="ml-2" v-if="getRouteImage(item.name)">
                <img :src="getRouteImage(item.name)" :alt="item.name" />
                </v-avatar>
                {{ item.name }}
            </template>
            
            <template v-slot:item="{ item }">
                <v-avatar size="20" class="ml-2" v-if="getRouteImage(item.name)">
                <img :src="getRouteImage(item.name)" :alt="item.name" :sizes="20" />
                </v-avatar>
                {{ item.name }}
            </template>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="formData.token"
              label="توکن"
              outlined
              dense
              required
              row="5"
              :rules="[v => !!v || 'فیلد توکن الزامی است']"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="formData.email"
              label="ایمیل (Email)"
              type="email"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="formData.password"
              label="رمز عبور (Password)"
              type="password"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="formData.req_lef"
              label="محدودیت درخواست"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </custom-popup>
  </v-card>
</template>

<script>
import ManageButton from '../aiAssistant/manageButton.vue';

export default {
  name: "TokenManager",
  components: {
    ManageButton,
  },
  data() {
    return {
      loading: false,
      showPopup: false,
      isEditing: false,
      valid: true,
      
      tokensData: { data: [], current_page: 1, per_page: 10, total: 0 },
      routes: [],       
      tableProps: {
        search: "",
        length: 10,
        page: 1,
        route:null,
        status:null,
      },
      
      formData: {
        id: null,
        token: "",
        email: "",
        password: "",
        req_lef: 0,
        meta: null,
        route: null,
      },

      headers: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        { value: "id", text: "شناسه", align: "center", sortable: true },
        { value: "email", text: "ایمیل", align: "center", sortable: true },
        { value: "token", text: "توکن", align: "center", sortable: false },
        { value: "api_route_id", text: "نوع", align: "center", sortable: true },
        { value: "enable", text: "وضعیت", align: "center", sortable: true },
        { value: "action", text: "عملیات", align: "center", sortable: false },
      ],

      metaButtons: {
        buttons: [
          {
            name: "edit",
            label: "ویرایش",
            icon: "pencil",
            class: "btn-edit border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "changeState",
            label: "تغییر وضعیت",
            icon: "swap-horizontal",
            class: "btn-warning border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-can",
            class: "btn-delete border-2 rounded-pill",
            action: this.action,
          },
        ],
      },
    };
  },
  
  mounted() {
    this.fetchRoutes();
    this.fetchTokens();
  },

  methods: {
        copyToClipboard(text) {
      if (!text) {
        this.$toast.warning("توکن برای کپی وجود ندارد");
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.$toast.success("توکن با موفقیت کپی شد", {
          position: "bottom-center",
          timeout: 2000,
        });
      });
    },
      getRouteImage(routeName) {
    if (!routeName) return '';
    
    const name = routeName.toLowerCase();
    
    const imageMap = {
      'chatgptplus': 'chatgpt.webp',
      'deepseek': 'deepseek.webp',
      'gemini': 'gemini.webp',
      'openrouter': 'openrouter.webp',
      'pixlr': 'pixlr.webp',
      'pebblely': 'pebblely.webp',
      'together': 'together.webp',
      'togather': 'together.webp',
    };

    const fileName = imageMap[name];
    if (fileName) {
      try {
        return require(`@/assets/media/type/${fileName}`);
      } catch (e) {
        return '';
      }
    }
    return ''; 
  },
    async fetchRoutes() {
      try {
        const { data } = await this.$api.get(`${this.$aiApi}/route/`);
        this.routes = data.data || [];
      } catch (error) {
        console.error("Error fetching routes", error);
      }
    },

    // گرفتن لیست توکن‌ها برای جدول
    async fetchTokens(props = this.tableProps) {
      this.loading = true;
      try {
        let param ={
            page: props.page,
            length: props.length,
        };
        if(props?.search?.trim()!=='')
            param.search= props?.search?.trim();
        if(props?.status!==null)
            param.status= props.status;
        if(props?.route!==null)
        param.route= props.route;

        const { data } = await this.$api.get(`${this.$aiApi}/token`, {
          params: param
        });
        this.tokensData = data.data || { data: [], current_page: 1, per_page: 10, total: 0 };
      } catch (error) {
        this.$toast.error("خطا در دریافت لیست توکن‌ها");
      } finally {
        this.loading = false;
      }
    },

    onPagination(e) {
      this.tableProps = { ...this.tableProps, ...e };
      this.fetchTokens();
    },

    applySearch() {
      this.tableProps.page = 1;
      this.fetchTokens();
    },

    // هدایت عملیات‌های ManageButton
    action(data, actionName) {
      this[`${actionName}Action`](data);
    },

    openAddPopup() {
      this.isEditing = false;
      this.formData = { id: null, token: "", email: "", password: "", req_lef: 0, meta: null, api_route_id: null };
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.showPopup = true;
    },

    editAction(item) {
      this.isEditing = true;
      this.formData = { ...item };
      this.showPopup = true;
    },

    async changeStateAction(item) {
      this.loading = true;
      try {
        await this.$api.get(`${this.$aiApi}/token/change/state/${item.id}`);
        this.$toast.success("وضعیت با موفقیت تغییر کرد");
        this.fetchTokens();
      } catch (error) {
        this.$toast.error("خطا در تغییر وضعیت");
      } finally {
        this.loading = false;
      }
    },

    async deleteAction(item) {
      if (await this.$modal.yesNo("آیا از حذف این توکن اطمینان دارید؟")) {
        this.loading = true;
        try {
          await this.$api.delete(`${this.$aiApi}/token/delete/${item.id}`);
          this.$toast.success("توکن با موفقیت حذف شد");
          this.fetchTokens();
        } catch (error) {
          this.$toast.error("خطا در حذف توکن");
        } finally {
          this.loading = false;
        }
      }
    },

    async saveToken() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      const url = this.isEditing 
        ? `${this.$aiApi}/token/update/${this.formData.id}`
        : `${this.$aiApi}/token/store`;
        
      try {
        await this.$api.post(url, this.formData);
        this.$toast.success(this.isEditing ? "توکن با موفقیت ویرایش شد" : "توکن با موفقیت ایجاد شد");
        this.showPopup = false;
        this.fetchTokens();
      } catch (error) {
        this.$toast.error("خطا در ذخیره اطلاعات");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
